module.exports = __webpack_public_path__ + "static/media/web-development.1a172407.png";